import { Button, Stack, ThemeProvider, Typography } from '@mui/material';
import { oldVyTheme } from '../../assets/old-themes/old-vy-theme';
import { useVyNavigate } from '../../hooks/use-vy-navigate';
import { NotFoundPageIcon } from '@vy/ui-design-system';

export const NotFoundPage = () => {
  const navigate = useVyNavigate();

  return (
    <ThemeProvider theme={oldVyTheme}>
      <Stack
        sx={{
          height: "100%",
          alignItems: "center",
          justifyContent: "center"
        }}>
        <NotFoundPageIcon style={{ marginBottom: 14 }} />
        <Typography
          variant="body1"
          align="center"
          sx={{
            fontWeight: 600,
            marginBottom: "4px"
          }}>
          Something went off track
        </Typography>
        <Typography
          variant="body2"
          align="center"
          sx={{
            maxWidth: "360px",
            marginBottom: "14px",
            color: '#7E8796'
          }}>
          We're already working to get things back to normal - hit "Go back" or refresh the page to retry.
        </Typography>

        <Button
          size="large"
          variant="outlined"
          onClick={() => navigate(-1)}
          sx={{ backgroundColor: '#E8EBF2', border: 'none' }}
        >
          Go back
        </Button>
      </Stack>
    </ThemeProvider>
  );
};
